import { render, staticRenderFns } from "./BulkAddRoutes.vue?vue&type=template&id=725c9e38&"
import script from "./BulkAddRoutes.vue?vue&type=script&lang=js&"
export * from "./BulkAddRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports